var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M631.2,341.2c11.7-11.7,11.7-30.7,0-42.4l-180-180.1c-8.6-8.6-21.5-11.1-32.7-6.5-11.2,4.6-18.5,15.6-18.5,27.7v100h-140c-33.1,0-60,26.9-60,60v40c0,33.1,26.9,60,60,60h140v100c0,12.1,7.2,23.1,18.5,27.7,11.2,4.6,24.1,2.1,32.7-6.5l180-180ZM200,120c22.1,0,40-17.9,40-40s-17.9-40-40-40h-80C53.7,40,0,93.8,0,160v320c0,66.2,53.7,120,120,120h80c22.1,0,40-17.9,40-40s-17.9-40-40-40h-80c-22.1,0-40-17.9-40-40V160c0-22.1,17.9-40,40-40h80Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.386697ebc78e9fc0ebde6c7483cba3be.svg";
export { ForwardRef as ReactComponent };